module.exports = __webpack_public_path__ + "static/sixstories-vk-2a38eaf80511532b5a16b789ba3ba595.jpg";